<template>
  <div class="page-with-top-bar">
    <project-admin-quick-buttons hiddenOption="report-config" />
    <section>
      <div class="mt-4">
        <!-- Un solo apartado: "Informe detallado" (galería de plantillas + card del
             Constructor de páginas). El selector de tipo de informe vive dentro. -->
        <report-templates :project-id="projectId" :activity-groups="activityGroups" />
      </div>
    </section>
  </div>
</template>

<script>
import axios from "axios";
import { mapGetters } from 'vuex'

import ProjectAdminQuickButtons from '·/components/project-admin-quick-buttons'
import ReportTemplates from './report-template/report-templates.vue'

export default {
  components: {
    ProjectAdminQuickButtons,
    ReportTemplates,
  },
  middleware: "auth",
  title: "report_config",
  menuOption: "0-2",

  computed: {
    ...mapGetters({ navData: 'app/navData' }),
  },

  data: () => ({
    projectId: null,
    activityGroups: [],
  }),

  created() {
    this.$options.subtitle = ['project_actions_page_subtitle', [this.navData.project_name.toUpperCase()]]
    this.projectId = this.navData.project_id
    this.loadActivityGroups()
  },

  methods: {
    async loadActivityGroups() {
      try {
        const { data } = await axios.get(
          `/api/v2/project/${this.projectId}/activity/groups`,
          { params: { full_tree: 1 } }
        )
        this.activityGroups = (data.groups || []).map(this.mapGroupToTree)
      } catch (e) {
        this.$buefy.toast.open({ message: this.$t('error_loading_data'), type: 'is-danger' })
      }
    },

    mapGroupToTree(g) {
      // code_custom/code se conservan para el auto-enlace disciplina↔grupo del builder.
      const node = { id: g.id, label: g.name, parent_id: g.parent_id, code_custom: g.custom_code ?? null, code: g.code ?? null }
      if (g.children && g.children.length) node.children = g.children.map(this.mapGroupToTree)
      return node
    },
  },
}
</script>
